"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNetwork = void 0;
const react_1 = require("react");
const providers_1 = require("../providers");
const network_1 = require("../network");
/**
 * Hook for accessing the current connected chain.
 *
 * @remarks
 *
 * The network object contains information about the
 * network.
 *
 * @example
 * This example shows how to display the current network name.
 * ```tsx
 * function Component() {
 *   const { chain } = useNetwork()
 *
 *   return <span>{chain && chain.name}</span>
 * }
 */
function useNetwork() {
    const { library } = (0, providers_1.useStarknet)();
    const [chain, setChain] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (library) {
            library.getChainId().then((chainId) => setChain((0, network_1.chainById)(chainId)));
        }
        else {
            // library should be always defined, but if it's not then
            // we reset the chain to undefined.
            setChain(undefined);
        }
    }, [library]);
    return { chain };
}
exports.useNetwork = useNetwork;
//# sourceMappingURL=network.js.map